import styled from '@emotion/styled'
import {ReactNode} from 'react'

const Container = styled.div`
  display: inline-block;
  font-family: Roboto;
  font-size: 1.5rem;
`

const Symbol = styled.span`
  font-size: 1rem;
  padding-right: 0.25rem;
`

// Split the leading currency prefix (e.g. "$", "€", "USC") from the number so it
// can be rendered smaller. This replaces a `::first-letter` rule that only shrank
// the first glyph, which mangled multi-letter codes like USC into "uSC10.00".
const splitCurrencyPrefix = (value: string) => {
  const match = /^(\D+)(\d.*)$/.exec(value)
  return match ? {symbol: match[1], rest: match[2]} : {symbol: '', rest: value}
}

type AmountProps = {
  children?: ReactNode
  className?: string
}

export const Amount = ({children, className}: AmountProps) => {
  if (typeof children !== 'string') {
    return <Container className={className}>{children}</Container>
  }
  const {symbol, rest} = splitCurrencyPrefix(children)
  return (
    <Container className={className}>
      {symbol && <Symbol>{symbol}</Symbol>}
      {rest}
    </Container>
  )
}

export const GreenAmount = styled(Amount)`
  color: #1DCD9A;
`
